'use strict';

var _ = require('lodash');

function buttonDirective () {

  function compile ($el, attrs) {

    var $button = $el.children().eq(0);
    var $buttonContent = $button.children().eq(0);

    // move the icon element after the label if necessary
    if (attrs.icon && (attrs.iconPosition === 'bottom')) {
      var $icon = $buttonContent.children().eq(0).detach();
      $buttonContent.append($icon);
    }

    if (attrs.ngClick) {
      var msg = [
        'Use the button directive `clickFn` attribute',
        'because `ng-click` does not respect `ng-disabled`'
      ].join(' ');

      // show warning message if using ng-click
      console.warn(msg);
    }

    return {
      post: link
    };
  }

  function link ($scope, $el, attrs, ctrls, $transclude) {
    var $button;
    var $buttonContent;

    var buttonCtrl = ctrls[0];
    var containerCtrl = ctrls[1];

    containerCtrl.register($scope.$id, buttonCtrl);

    // list of attributes to move from el to the button element
    var attrsToMove = ['type', 'tabindex'];

    $button = $el.children().eq(0);
    $buttonContent = $button.children().eq(0);

    // initialize the controller
    buttonCtrl.init();

    // move classes to the button element
    if (attrs.class) {
      $button.addClass(attrs.class);
      $el.removeClass(attrs.class);
    }

    // set the button classes that cannot change
    $button.addClass(buttonCtrl.getButtonClasses());

    _.forEach(attrsToMove, function (attr) {
      if (attrs[attr]) {
        $button.attr(attr, attrs[attr]);
        $el[0].removeAttribute(attr);
      }
    });

    // add transcluded elements
    $transclude(function (clone) {
      $buttonContent.prepend(clone);
    });

    if (!buttonCtrl.label) {
      if ($buttonContent[0].querySelector('.button-label')) {
        $button.addClass('has-label');
        buttonCtrl.showLabel = true;
      }
    }

    // check to see if there is an icon (.button-icon) added via the trancluded content
    if (!buttonCtrl.icon) {
      if ($buttonContent[0].querySelector('.button-icon')) {
        $button.addClass('has-icon');
      }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////.

    /**
     * Add or remove an "active" class. Currently this will happen on every click, regardless
     * of whether or not the button can be "activated". If this causes problems in the future,
     * it can be made into a directive attribute
     */
    function onClick (e) {
      if (!buttonCtrl.disabled) {

        if (attrs.clickFn) {
          $scope.$applyAsync(buttonCtrl.clickFn);
        }

        if ($button.hasClass('active')) {
          $button.removeClass('active');
        } else {
          $button.addClass('active');
        }
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    $el.on('click', onClick);
  }

  return {
    bindToController: true,
    compile: compile,
    // link: link,
    controller: 'ButtonController',
    controllerAs: 'buttonController',
    require: ['sbButton', '^sbButtonContainer'],
    restrict: 'A',
    scope: {
      clickFn: '&?', // this should be used instead of ng-click
      loading: '=?loading',
      loadingLabel: '@',
      disabled: '=?disable',
      icon: '@',
      iconPosition: '@', // one of left, right, top, or bottom
      iconShape: '@',
      label: '@',
      show: '=?',
      showLabel: '=?',
      size: '@',
    },
    templateUrl: 'saturn/button/button/button.tpl.html',
    transclude: true
  };
}

module.exports = buttonDirective;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/button/src/button/ButtonDirective.js